"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { tabsAnatomy } from "@chakra-ui/react/anatomy"

const tab = defineSlotRecipe({
  className: "hydrologiq-tab",
  slots: tabsAnatomy.keys(),

  variants: {
    variant: {
      primary: {
        root: {
          backgroundColor: "transparent",
          border: "none",
          boxShadow: "none",
        },

        list: {
          border: "none",
          boxShadow: "none",
          pb: "3px",
          width: "100%",
          flexDirection: "row-reverse !important",
        },

        trigger: {
          borderBottom: "3px solid",
          borderColor: "#a9a9a9",
          fontSize: "15px",
          fontWeight: 600,
          backgroundColor: "transparent",
          boxShadow: "none",

          _selected: {
            color: "active !important",
            borderColor: "active !important",
          },

          _disabled: {
            opacity: 0.5,
            cursor: "not-allowed",
          },

          _hover: {
            cursor: "pointer",
            color: "#0bc5ea",
            borderColor: "#0bc5ea",
          },
        },

        indicator: {
          boxShadow: "none",
          border: "none",
        },

        content: {
          boxShadow: "none",
          border: "none",
        },
      },

      topLevel: {
        list: {
          display: "flex",
          gap: "24px",
          border: "none",
          background: "transparent",
        },

        trigger: {
          padding: "10px 0",
          background: "transparent",
          border: "none",
          borderBottom: "3px solid transparent",
          fontSize: "15px",
          fontWeight: "600",
          color: "primary",
          cursor: "pointer",
          transition: "color 0.15s, border-color 0.15s",
          borderRadius: "0",

          _hover: {
            color: "#0bc5ea",
            borderColor: "#0bc5ea",
            background: "transparent",
          },

          _selected: {
            color: "#a170d9",
            borderColor: "#a170d9",
            background: "transparent",
          },
        },

        content: {
          padding: "0",
        },
      },

      sectionLozenge: {
        root: {
          width: "100%",
        },

        list: {
          display: "flex",
          gap: "4px",
          border: "none",
          background: "transparent",
          marginBottom: "-1px",
          position: "relative",
          zIndex: 1,
          width: "100%",
        },

        trigger: {
          padding: "8px 18px",
          background: "transparent",
          border: "none",
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
          borderBottomLeftRadius: "0",
          borderBottomRightRadius: "0",
          fontSize: "15px",
          fontWeight: "500",
          color: "primary",
          cursor: "pointer",
          transition: "background 0.15s, color 0.15s",

          _hover: {
            background: "card",
            color: "primary",
          },

          _selected: {
            background: "card",
            border: "none",
            borderBottom: "none",
            paddingBottom: "9px",
            zIndex: 2,
            color: "primary",
            boxShadow: "0 -1px 3px rgba(0, 0, 0, 0.06)",
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",

            _hover: {
              background: "card",
            },
          },
        },

        content: {
          background: "card",
          border: "none",
          borderRadius: "{radii.card}",
          padding: "20px",
          width: "100%",
          boxShadow: "{shadows.card}",
        },
      },
    },
  },
})

export default tab
